import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=62c4fdca&"
import script from "./PromotionDetails.vue?vue&type=script&lang=js&"
export * from "./PromotionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetails.vue?vue&type=style&index=0&id=62c4fdca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports